import BaseApi from "../../../services/baseApi";

class Reporting {
    constructor() {
        this.entity = 'detailsUintReport';
    }

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    getBuildingItems( buildingId) {
        let formData=new FormData();
        formData.set("buildingId",buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/getBuildingItems/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    search(model){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:model,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })

     }
    download(uuid){
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/common/download?uuid='+uuid,
            headers: {'Content-Type': 'application/json'},
            responseType: 'blob'

        })
    }


}
export default new Reporting();
